import React from 'react';
import { Button, Stack } from '@mui/material';

export default function MobileTermsActions({ onAccept, onDecline }) {
  return (
    <Stack spacing={1.25}>
      <Button variant="contained" color="primary" fullWidth onClick={onAccept} sx={{ minHeight: 52 }}>
        Hyväksyn ehdot ja jatkan hakemusta
      </Button>
      <Button variant="outlined" color="secondary" fullWidth onClick={onDecline} sx={{ minHeight: 48 }}>
        En hyväksy — palaa alkuun
      </Button>
    </Stack>
  );
}
